import React from 'react'
import { Button, Placeholder } from 'react-bootstrap'
import { IoWarningOutline } from 'react-icons/io5'

// Erro de carga dentro do próprio bloco, com Tentar de novo (nunca vira 0)
export const BlockError = ({ message, onRetry, className = '' }) => (
  <div className={`dashboard-error ${className}`} role='alert'>
    <span>{message || 'Não foi possível carregar os dados.'}</span>
    {onRetry ? <Button variant='outline-secondary' size='sm' onClick={onRetry}>Tentar de novo</Button> : ''}
  </div>
)

// Faixa de aviso (status sem significado, data futura)
export const WarningStrip = ({ children }) => (
  <p className='dashboard-warning' role='note'>
    <IoWarningOutline aria-hidden='true' className='flex-shrink-0' />
    <span>{children}</span>
  </p>
)

// Esqueleto de um gráfico na primeira carga
export const ChartSkeleton = ({ height = 240 }) => (
  <Placeholder as='div' animation='glow' aria-hidden='true'>
    <Placeholder className='dashboard-skeleton-chart' style={{ height }} />
  </Placeholder>
)

export const KpiSkeleton = ({ count = 6 }) => (
  Array.from({ length: count }).map((_, index) => (
    <div className='dashboard-kpi' key={index} aria-hidden='true'>
      <Placeholder as='div' animation='glow'>
        <Placeholder xs={7} size='sm' />
        <Placeholder xs={5} size='lg' className='d-block my-1' />
        <Placeholder xs={9} size='sm' />
      </Placeholder>
    </div>
  ))
)
